import React from "react";
import { Sparkles, ArrowRight } from "lucide-react";

export function CreditCalculator({ t, onNavigateToCalculator }) {
    const examples = [
        { credits: 20, description: t("billing.creditExamples.simpleForm") || "Simple form or app screen" },
        { credits: 200, description: t("billing.creditExamples.fullApp") || "Full app with database" },
        { credits: 200, description: t("billing.creditExamples.complexDashboard") || "Complex analytics dashboard" },
    ];

    return (
        <div className="bg-gradient-to-br from-slate-50 to-indigo-50/50 rounded-2xl p-6 md:p-8 border border-slate-200/80">
            <div className="flex items-start gap-4 mb-6">
                <div className="w-10 h-10 rounded-xl bg-indigo-100 flex items-center justify-center flex-shrink-0">
                    <Sparkles className="w-5 h-5 text-indigo-600" />
                </div>
                <div>
                    <h3 className="text-lg font-semibold text-slate-900 mb-1">
                        {t("billing.creditCalculator.title") || "What can you build?"}
                    </h3>
                    <p className="text-sm text-slate-500">
                        {t("billing.creditCalculator.subtitle") || "Here's what you can build with your AI capacity"}
                    </p>
                </div>
            </div>

            <div className="grid gap-3">
                {examples.map((example, index) => (
                    <div
                        key={index}
                        className="flex items-center justify-between bg-white rounded-xl px-4 py-3 border border-slate-100"
                    >
                        <span className="text-sm text-slate-700">{example.description}</span>
                        <span className="text-sm font-semibold text-indigo-600 bg-indigo-50 px-3 py-1 rounded-full">
                            ~{example.credits}
                        </span>
                    </div>
                ))}
            </div>

            {onNavigateToCalculator && (
                <button
                    onClick={onNavigateToCalculator}
                    className="mt-6 pt-5 border-t border-slate-200 w-full flex items-center justify-between text-left hover:opacity-80 transition-opacity group"
                >
                    <div className="text-left">
                        <span className="text-sm font-semibold text-indigo-700">
                            {t("billing.creditCalculator.howManyCredits") || "How many credits do I need?"}
                        </span>
                        <p className="text-xs text-slate-500 mt-0.5">
                            {t("billing.creditCalculator.howManyCreditsDesc") || "Use our calculator to estimate costs by module"}
                        </p>
                    </div>
                    <ArrowRight className="w-4 h-4 text-indigo-400 group-hover:translate-x-0.5 transition-transform" />
                </button>
            )}
        </div>
    );
}
